import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';

@Injectable()
export class FileService {
  constructor(
    private toastrService: ToastrService,
    private translateService: TranslateService
  ) {}

  private mbSize = 1000;

  validateMaximumAllowedSize(
    file: File,
    maxAllowedSizeMb: number
  ): ValidationErrors | null {
    const maxAllowedSize = maxAllowedSizeMb * this.mbSize;
    const fileSize = file.size / this.mbSize;

    if (fileSize > maxAllowedSize) {
      this.translateService
        .get('SHARED.UPLOAD-DOCUMENT-TITLE')
        .subscribe(title => {
          this.translateService
            .get('SHARED.UPLOAD-DOCUMENT-FILE-TOO-LARGE', {
              value: maxAllowedSizeMb
            })
            .subscribe(fileTooLargeInfo => {
              this.toastrService.error(fileTooLargeInfo, title);
            });
        });
      return { isValid: false };
    }
    return null;
  }

  validateExtensions(
    file: File,
    validExtensions: string[]
  ): ValidationErrors | null {
    const fileExtension = file.name.substr(file.name.lastIndexOf('.') + 1);

    if (!validExtensions.includes(fileExtension.toLowerCase())) {
      this.translateService
        .get('SHARED.UPLOAD-DOCUMENT-TITLE')
        .subscribe(title => {
          this.translateService
            .get('SHARED.UPLOAD-DOCUMENT-WRONG-EXTENSION')
            .subscribe(invalidExtensionInfo => {
              this.toastrService.error(invalidExtensionInfo, title);
            });
        });
      return { isValid: false };
    }
    return null;
  }

  validateExtensionsAndMaximumAllowedSize(
    file: File,
    validExtensions: string[],
    maxAllowedSizeMb: number
  ): ValidationErrors | null {
    const fileExtension = file.name.substr(file.name.lastIndexOf('.') + 1);
    const maxAllowedSize = maxAllowedSizeMb * this.mbSize;
    const fileSize = file.size / this.mbSize;
    if (!validExtensions.includes(fileExtension.toLowerCase())) {
      this.translateService
        .get('SHARED.UPLOAD-DOCUMENT-TITLE')
        .subscribe(title => {
          this.translateService
            .get('SHARED.UPLOAD-DOCUMENT-WRONG-EXTENSION')
            .subscribe(invalidExtensionInfo => {
              this.toastrService.error(invalidExtensionInfo, title);
            });
        });
      return { isValid: false };
    } else if (fileSize > maxAllowedSize) {
      this.translateService
        .get('SHARED.UPLOAD-DOCUMENT-TITLE')
        .subscribe(title => {
          this.translateService
            .get('SHARED.UPLOAD-DOCUMENT-FILE-TOO-LARGE', {
              value: maxAllowedSizeMb
            })
            .subscribe(fileTooLargeInfo => {
              this.toastrService.error(fileTooLargeInfo, title);
            });
        });
      return { isValid: false };
    }
    return null;
  }

  excelToJson(excelFile: File, sheetName: string, callback: any): void {
    const reader = new FileReader();
    let buffers: ArrayBuffer | string;
    reader.readAsArrayBuffer(excelFile);
    reader.onload = function() {
      buffers = reader.result;
      const workbook = XLSX.read(buffers, { type: 'buffer' });
      const bidsSheet = workbook.Sheets[sheetName];
      const bidsSheetJson = XLSX.utils.sheet_to_json(bidsSheet, {
        header: 1,
        defval: '',
        blankrows: true
      });
      callback(bidsSheetJson);
    };
  }
}
